import React from "react";
import { Link, useLocation } from "react-router-dom";
import { CalendarHeart } from "lucide-react";

/**
 * Floating "Request a Visit" CTA — visible on every page except the placement form itself
 * and dashboards (where it would just duplicate existing CTAs).
 * Routes the caregiver to /placement-help so the lead goes to the advisor inbox.
 */
export default function RequestVisitFAB() {
  const { pathname } = useLocation();
  const hide =
    pathname.startsWith("/placement-help") ||
    pathname.startsWith("/dashboard") ||
    pathname.startsWith("/billing");
  if (hide) return null;

  return (
    <Link
      to="/placement-help"
      data-testid="request-visit-fab"
      className="fixed bottom-5 right-5 z-50 inline-flex items-center gap-2 rounded-full bg-primary px-5 py-3.5 text-sm font-semibold text-primary-foreground shadow-lg ring-1 ring-emerald/30 transition-transform hover:-translate-y-0.5 hover:shadow-xl sm:bottom-7 sm:right-7 sm:px-6 sm:py-4 sm:text-base"
    >
      <CalendarHeart className="h-4 w-4 sm:h-5 sm:w-5" />
      Request a Visit
    </Link>
  );
}
